/*
 * DATA_RIGHTS: HONEYWELL CONFIDENTIAL AND PROPRIETARY
 * THIS WORK CONTAINS VALUABLE CONFIDENTIAL AND PROPRIETARY
 * INFORMATION. DISCLOSURE, USE OR REPRODUCTION OUTSIDE OF
 * HONEYWELL INTERNATIONAL, INC. IS PROHIBITED EXCEPT AS
 * AUTHORIZED IN WRITING. THIS UNPUBLISHED WORK IS PROTECTED BY
 * THE LAWS OF THE UNITED STATES AND OTHER COUNTRIES. IN THE
 * EVENT OF PUBLICATION, THE FOLLOWING NOTICE SHALL APPLY:
 * Copyright (C) 2022 HONEYWELL INTERNATIONAL, INC., ALL RIGHTS RESERVED.
 *
 * Created by H144765 on 4/4/2022.
 */

import React from 'react'
import {FormattedMessage, injectIntl} from 'react-intl';
import {Card, List} from '@scuf/common';
import {withRouter} from "react-router";
import connect from "react-redux/es/connect/connect";
import {bindActionCreators} from "redux";
import * as FaultActions from "../FaultActions";
import {ACCESS, FAULT_STATES, isClosedState} from "../common/FaultsConst";
import {Link} from "react-router-dom";
import {getReadOnlyStatus} from "../common/FaultsUtils";

class SimilarFaultCard extends React.Component {

    goToFault() {
        this.props.FaultActions.clearState();
    }

    getSymptomItems(symptoms) {
        return symptoms.map(s => <List.Content key={s.id}>{s.name}</List.Content>)
    }

    render() {
        const {fault, intl} = this.props
        const faultName = fault.name + ': ' + fault.primarySymptomName
        // Fault with name starting 'Alert#' and with NEW state will be on UI shown with state 'NEW_ALERT' (this state doesn't really exist in DB)
        let newFaultState = fault.currentState
        if((fault.name.startsWith('Alert#')) && (newFaultState === FAULT_STATES.NEW)) {
            newFaultState = FAULT_STATES.NEW_ALERT;
        }
        return (
            <Link to={`/assets/${fault.assetId}/faults/${fault.id}`} target="_self">
                <Card className={'similar-card state-' + newFaultState}>
                    <Card.Header>
                        <div className='state-icon' />
                        <div className='fault-name' title={faultName}>{faultName}</div>
                        {fault.assignedUser !== null ?
                            <div className='assignee'
                                 title={fault.assignedUser.displayName}>{fault.assignedUser.firstName.charAt(0) + fault.assignedUser.lastName.charAt(0)}</div>
                            :
                            null
                        }
                    </Card.Header>
                    <Card.Meta>
                        <div className='state-name'>{intl.formatMessage({id: "fault.detail.state." + newFaultState})}</div>
                        {getReadOnlyStatus(this.props)}
                        <div className="asset-name"> {fault.assetName}</div>
                    </Card.Meta>
                    <Card.Content>
                        <FormattedMessage id={"fault.similarity"}/>
                        <span><b>{Math.round(fault.commonAllocatedSymptoms.length/this.props.numberOfAllocatedSymptoms*100)}%</b></span>
                    </Card.Content>
                    <Card.Footer>
                    </Card.Footer>
                </Card>
            </Link>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        security: state.security,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        FaultActions: bindActionCreators(FaultActions, dispatch),
    }
}

export default injectIntl(withRouter(connect(mapStateToProps, mapDispatchToProps)(SimilarFaultCard)))